import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useHistory  } from 'react-router-dom'; // useHistory instead of useNavigate

const theme = createTheme({
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: '1.25rem',
          backgroundColor: 'purple',
          color: 'white',
        },
      },
    },
  },
});

const NotificationSnacker = ({ open, message, severity, onClose }) => {
  const history = useHistory (); // useHistory hook for navigation

  const handleClick = () => {
    history.push('/web_app/chat'); 
  };

  return (
    <ThemeProvider theme={theme}>
      <Snackbar open={open} autoHideDuration={9000} onClose={onClose}>
        <Alert onClick={handleClick} onClose={onClose} severity={severity} style={{ cursor: 'pointer' }}>
          {message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
};

export default NotificationSnacker;
